import { StandardButton } from "../atoms/buttons"
import { icon } from "../functions/icons"

export const ButtonBar  = ({next, back, style}) => {
    return(

        <div className="horizontal space-between assesment-btn-group" style={style}>
            <StandardButton onClick={back} left={true}  className={"small-standard-padding go-back-btn"} title={<>{icon("arrow-left")}&nbsp;&nbsp;&nbsp;Terug</>}/>
            <StandardButton onClick={next} arrow="no"  className={"small-standard-padding"} title={<>Volgende&nbsp;&nbsp;&nbsp;{icon("arrow-right")}</>}/>
        </div>
    )
}